<div class="prf-diagnostics-of-interests-card">
  <prf-image [image]="card.image" />
  <prf-h3 class="prf-diagnostics-of-interests-card-title">{{ card.title }}</prf-h3>
</div>
